// extracted by mini-css-extract-plugin
export default {"methodIem":"payBnb_methodIem__gE865","img":"payBnb_img__3am0L"};